// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_track_details_unlimited_music_pricing = /** @type {(inputs: { oldPrice: NonNullable<unknown>, price: NonNullable<unknown> }) => string} */ (i) => {
	return `Get unlimited assets for only <s>${i.oldPrice}</s> <b>${i.price}</b>/month — or purchase this SFX on its own.`
};

const de_track_details_unlimited_music_pricing = /** @type {(inputs: { oldPrice: NonNullable<unknown>, price: NonNullable<unknown> }) => string} */ (i) => {
	return `Nur <s>${i.oldPrice}</s> <b>${i.price}</b>/Monat. 7 Tage kostenlos. Jederzeit kündbar.`
};

const es_track_details_unlimited_music_pricing = /** @type {(inputs: { oldPrice: NonNullable<unknown>, price: NonNullable<unknown> }) => string} */ (i) => {
	return `Solo <s>${i.oldPrice}</s> <b>${i.price}</b> al mes. 7 días gratis. Cancela en cualquier momento.`
};

const pt_br_track_details_unlimited_music_pricing = /** @type {(inputs: { oldPrice: NonNullable<unknown>, price: NonNullable<unknown> }) => string} */ (i) => {
	return `Apenas <s>${i.oldPrice}</s> <b>${i.price}</b>/mês. 7 dias grátis. Cancele a qualquer momento.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ oldPrice: NonNullable<unknown>, price: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "pt-br" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const track_details_unlimited_music_pricing = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.track_details_unlimited_music_pricing(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("track_details_unlimited_music_pricing", locale)
	if (locale === "en") return en_track_details_unlimited_music_pricing(inputs)
	if (locale === "de") return de_track_details_unlimited_music_pricing(inputs)
	if (locale === "es") return es_track_details_unlimited_music_pricing(inputs)
	return pt_br_track_details_unlimited_music_pricing(inputs)
};
export { track_details_unlimited_music_pricing as "track-details.unlimited-music-pricing" }